/* Carrusel 3D (cover flow) — se auto-inicializa sobre [data-cover-flow].
   Sin dependencias: no usa jQuery ni el objeto halo. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function CoverFlow(stage) {
    this.stage = stage;
    this.track = stage.querySelector('[data-cf-track]');
    this.items = Array.prototype.slice.call(stage.querySelectorAll('[data-cf-item]'));
    if (!this.track || this.items.length === 0) return;

    var dotsWrap = stage.parentNode.querySelector('[data-cf-dots]');
    this.dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-cf-dot]')) : [];

    this.visibleSides = parseInt(stage.dataset.visibleSides, 10) || 2;
    this.scale = parseFloat(stage.dataset.sideScale) || 0.8;
    this.rotate = parseFloat(stage.dataset.sideRotate) || 35;
    this.offset = parseFloat(stage.dataset.sideOffset) || 60;

    // Arranca en la primera tarjeta. El bucle hace que la activa quede siempre
    // en el centro y con vistas previas a ambos lados, tambien en los extremos.
    this.index = 0;
    this.reduced = REDUCED;
    this.hidden = false;

    var total = this.items.length;
    this.loop = !this.reduced && total >= 3;
    // Con pocas tarjetas una misma no puede asomar a izquierda y derecha a la vez.
    this.sides = this.loop
      ? Math.min(this.visibleSides, Math.floor((total - 1) / 2))
      : this.visibleSides;

    if (this.reduced) {
      stage.classList.add('is-reduced');
    }

    this.bind();
    this.render();
    this.observe();
  }

  CoverFlow.prototype.bind = function () {
    var self = this;

    var prev = this.stage.querySelector('[data-cf-prev]');
    var next = this.stage.querySelector('[data-cf-next]');
    if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
    if (next) next.addEventListener('click', function () { self.go(self.index + 1); });

    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        self.go(parseInt(dot.dataset.cfDot, 10));
      });
    });

    // Clic en una tarjeta lateral: la centra en lugar de seguir el enlace.
    this.items.forEach(function (item, i) {
      item.addEventListener('click', function (e) {
        if (self.reduced || i === self.index) return;
        e.preventDefault();
        self.go(i);
      });
    });

    // Teclado: flechas izquierda / derecha sobre el carrusel.
    this.stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index + 1); }
    });

    // Al cruzar el corte de movil cambian el ancho de tarjeta y la apertura.
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { self.render(); }, 150);
    });

    if (!this.reduced) this.bindDrag();
  };

  CoverFlow.prototype.bindDrag = function () {
    var self = this;
    var viewport = this.stage.querySelector('.cover-flow__viewport');
    if (!viewport) return;

    var startX = 0;
    var dragging = false;
    var stepped = false;
    var pointerId = null;

    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      stepped = false;
      pointerId = e.pointerId;
      startX = e.clientX;
      self.stage.classList.add('is-dragging');
    });

    /* Un arrastre = un paso, con la misma animacion que las flechas.
       `stepped` evita que un gesto largo dispare varios saltos seguidos. */
    viewport.addEventListener('pointermove', function (e) {
      if (!dragging || stepped || e.pointerId !== pointerId) return;
      var delta = e.clientX - startX;
      if (Math.abs(delta) > self.cardWidth() * 0.2) {
        stepped = true;
        self.go(self.index + (delta < 0 ? 1 : -1));
      }
    });

    function end(e) {
      if (!dragging || (e && e.pointerId !== pointerId)) return;
      dragging = false;
      stepped = false;
      pointerId = null;
      self.stage.classList.remove('is-dragging');
    }

    viewport.addEventListener('pointerup', end);
    viewport.addEventListener('pointercancel', end);
    viewport.addEventListener('pointerleave', end);

    // Evita que el arrastre del raton inicie un drag nativo de la imagen.
    viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });
  };

  CoverFlow.prototype.cardWidth = function () {
    return this.items[0] ? this.items[0].offsetWidth || 260 : 260;
  };

  /* Apertura del abanico, acotada por pantalla:
     - Movil: por encima de 60% las vistas previas se salen de pantalla.
     - Escritorio: por debajo de 95% las tarjetas se amontonan y el carrusel
       se ve compacto. Es un MINIMO, no un tope: si el ajuste pide mas, manda el ajuste. */
  CoverFlow.prototype.currentOffset = function () {
    return window.innerWidth <= 749
      ? Math.min(this.offset, 60)
      : Math.max(this.offset, 95);
  };

  /* Distancia de una tarjeta a la activa. Con bucle se toma el camino corto,
     asi que las de los extremos aparecen al otro lado en vez de dejar hueco. */
  CoverFlow.prototype.delta = function (i) {
    var total = this.items.length;
    var d = i - this.index;
    if (!this.loop) return d;
    if (d > total / 2) d -= total;
    if (d < -total / 2) d += total;
    return d;
  };

  CoverFlow.prototype.go = function (i) {
    var total = this.items.length;
    if (this.loop) {
      this.index = ((i % total) + total) % total;
    } else {
      var last = total - 1;
      this.index = i < 0 ? 0 : (i > last ? last : i);
    }
    this.render();
  };

  CoverFlow.prototype.render = function () {
    var self = this;
    var width = this.cardWidth();
    var total = this.items.length;
    var deltas = this.items.map(function (_, i) { return self.delta(i); });

    /* La tarjeta que da la vuelta salta de un extremo al otro. Con la transicion
       puesta recorre todo el carrusel por detras y se ve cruzar por los huecos
       entre tarjetas, asi que en ese salto se le corta la animacion. */
    var teleport = [];
    if (this.prevDeltas) {
      this.items.forEach(function (item, i) {
        if (Math.abs(deltas[i] - self.prevDeltas[i]) > total / 2) {
          item.classList.add('is-teleport');
          teleport.push(item);
        }
      });
      // Reflujo para que el corte de transicion surta efecto antes del nuevo transform.
      if (teleport.length) void this.track.offsetWidth;
    }
    this.prevDeltas = deltas;

    this.items.forEach(function (item, i) {
      var d = deltas[i];
      var abs = Math.abs(d);
      var dir = d === 0 ? 0 : (d < 0 ? -1 : 1);
      var active = d === 0;

      item.classList.toggle('is-active', active);

      if (!self.reduced) {
        var visible = abs <= self.sides;
        // Las laterales se acercan al centro: cada paso suma menos que el anterior.
        var shift = dir * (self.currentOffset() / 100) * width * (1 + (abs - 1) * 0.62);
        var scale = active ? 1 : Math.pow(self.scale, abs);
        var rotY = -dir * self.rotate;
        var depth = active ? 0 : -abs * 60;

        item.style.setProperty(
          '--cf-t',
          'translateX(' + shift.toFixed(2) + 'px) translateZ(' + depth + 'px) rotateY(' + rotY + 'deg) scale(' + scale.toFixed(3) + ')'
        );
        item.style.setProperty('--cf-o', visible ? '1' : '0');
        item.style.setProperty('--cf-z', String(100 - abs));
        item.style.setProperty('--cf-pe', visible ? 'auto' : 'none');
      }

      // El enlace solo es alcanzable con tabulador en la tarjeta centrada.
      var card = item.querySelector('[data-cf-card]');
      if (card && card.tagName === 'A') card.tabIndex = active ? 0 : -1;

      self.playVideo(item, active);
    });

    this.dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === self.index);
      dot.setAttribute('aria-current', i === self.index ? 'true' : 'false');
    });

    // Ya colocada en su sitio nuevo, se le devuelve la animacion para el siguiente paso.
    if (teleport.length) {
      void this.track.offsetWidth;
      requestAnimationFrame(function () {
        teleport.forEach(function (it) { it.classList.remove('is-teleport'); });
      });
    }

    if (this.reduced) this.scrollToActive();
    else this.fitFan(width);
  };

  /* Ajusta el ancho del carrusel al del abanico para que las flechas queden
     siempre junto a las tarjetas, sea cual sea el tamano configurado. */
  CoverFlow.prototype.fitFan = function (width) {
    var rad = this.rotate * Math.PI / 180;
    var scale = Math.pow(this.scale, this.sides);
    var shift = this.sides === 0
      ? 0
      : (this.currentOffset() / 100) * width * (1 + (this.sides - 1) * 0.62);
    // Media anchura visual de la tarjeta mas externa, ya rotada.
    var half = (width * scale * Math.cos(rad)) / 2;
    this.stage.style.setProperty('--cf-fan-width', Math.ceil((shift + half) * 2 + 24) + 'px');
  };

  CoverFlow.prototype.scrollToActive = function () {
    var item = this.items[this.index];
    var viewport = this.stage.querySelector('.cover-flow__viewport');
    if (!item || !viewport) return;
    viewport.scrollTo({
      left: item.offsetLeft - (viewport.clientWidth - item.offsetWidth) / 2,
      behavior: 'smooth'
    });
  };

  /* Solo reproduce el video de la tarjeta centrada; el resto se pausa.
     Con prefers-reduced-motion no se reproduce nada automaticamente. */
  CoverFlow.prototype.playVideo = function (item, active) {
    var video = item.querySelector('video');
    if (!video) return;

    if (active && !this.reduced && !this.hidden) {
      video.muted = true;
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    } else {
      video.pause();
    }
  };

  /* Fuera del viewport se pausan los videos para no gastar bateria. */
  CoverFlow.prototype.observe = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        self.hidden = !entry.isIntersecting;
        self.items.forEach(function (item, i) {
          self.playVideo(item, i === self.index);
        });
      });
    }, { threshold: 0.1 }).observe(this.stage);
  };

  function init(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-cover-flow]'), function (stage) {
      if (stage.dataset.cfReady) return;
      stage.dataset.cfReady = 'true';
      new CoverFlow(stage);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // El editor de temas recarga la seccion sin recargar la pagina.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
